import * as angular from "angular";
import { Webhook } from '../models/webhook.model';

export class WebhooksRequests {

  /* @ngInject */
  constructor(private WebhooksAPI, private $webhooks, private WebhooksConstants) {
  }

  getAll() {
    const api = this.WebhooksAPI.actions.getAll;
    return this.$$call(
      api, {}, {}, {});
  }

  create(webhook: Webhook) {
    const api = this.WebhooksAPI.actions.create;
    // const webhook = {topics: topics, deliveryUrl: deliveryUrl, secret: secret};
    return this.$$call(api, {}, webhook, {});
  }

  update(id, updatedWebhook: Webhook) {
    const api = this.WebhooksAPI.actions.update;
    return this.$$call(api, {}, updatedWebhook, {id: id});
  }

  remove(id) {
    const api = this.WebhooksAPI.actions.cancel;
    return this.$$call(api, {}, {}, {id: id});
  }

  getTopics() {
    const api = this.WebhooksAPI.actions.getTopics;
    return this.$$call(api, {}, {}, {});
    // return new Promise((resolve, reject) => {
    //   resolve(this.WebhooksConstants.topics);
    // });
  }



  private $$call(_apiCall, _params, _data, _options, id?) {
    return this.$webhooks(id).$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.webhooks')
  .service('webhooksRequests', WebhooksRequests);
